<template>
    <div>

        <v-data-table :loading="isLoading"
                      :headers="headers"
                      :items="allList" sort-by="calories" class="elevation-1" hide-default-footer>
            <template v-slot:top>
                <v-toolbar flat color="white">
                    <v-toolbar-title>Song Type</v-toolbar-title>
                    <v-divider class="mx-4" inset vertica></v-divider>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark
                           class="mb-2"
                           v-on:click="newItem()">New Song Type
                    </v-btn>
                    <v-dialog v-model="addEditDialog" max-width="500px">
                        <v-card>
                            <v-card-title>
                                <span class="headline">{{ formTitle }}</span>
                            </v-card-title>

                            <v-card-text>
                                <v-container>
                                    <v-row>
                                        <v-col cols="12" sm="6" md="4">
                                            <v-text-field :rules="[rules.required]" v-model="editedItem.name"
                                                          label="Name"></v-text-field>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </v-card-text>

                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn color="blue darken-1" text @click="close">Cancel</v-btn>
                                <v-btn color="blue darken-1" text @click="save">Save</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-toolbar>

                <v-text-field
                        v-on:keyup.enter="searchAll"
                        v-model="search"
                        label="Search"
                        single-line
                        hide-details
                        class="pb-3 px-3"
                ></v-text-field>
            </template>


            <template v-slot:item.actions="{ item }">
                <v-icon
                        small
                        class="mr-2"
                        @click="editItem(item)"
                >
                    mdi-pencil
                </v-icon>
                <v-icon
                        small
                        @click="deleteItem(item)"
                >
                    mdi-delete
                </v-icon>
            </template>
            <template v-slot:no-data>
                <v-btn color="primary" @click="initialize">Reset</v-btn>
            </template>
        </v-data-table>
        <pagination :page="page" :total-page="totalPage" @paginate="paginate($event)"></pagination>
    </div>
</template>

<script>
    import {mapGetters, mapActions, mapMutations} from 'vuex'
    import Pagination from '../../components/Pagination'

    export default {
        name: "SongTypePanel",
        components: {
            Pagination
        },
        data: () => ({
            loading: false,
            search: '',
            rules: {
                required: value => !!value || 'Required.'
            },
            headers: [
                {
                    text: 'Name',
                    align: 'start',
                    sortable: true,
                    value: 'name',
                },
                {text: 'Actions', value: 'actions', sortable: false},
            ],
            editedIndex: -1,
            editedItem: {
                parseItem: null,
                name: ''
            },
            defaultItem: {
                parseItem: null,
                name: '',
            },
        }),
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'New Song Type' : 'Edit Song Type'
            },
            page() {
                return this.getPagination().page;
            },
            perPage() {
                return this.getPagination().perPage;
            },
            totalPage() {
                return this.getPagination().totalPage;
            },
            allList() {
                return this.getAll();
            },
            isLoading() {
                return this.getLoading()
            },
            addEditDialog: {
                get() {
                    return this.showAddEditDialog();
                },
                set(value) {
                    this.setShowAddEditDialog(value);
                }
            }
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
        },
        created() {
            this.initialize()
        },
        methods: {
            ...mapMutations({
                setShowAddEditDialog: 'songType/SHOW_ADD_EDIT_DIALOG'
            }),
            ...mapGetters({
                getPagination: 'songType/getPagination',
                getLoading: 'songType/getLoading',
                getAll: 'songType/getAll',
                showAddEditDialog: 'songType/showAddEditDialog'
            }),
            ...mapActions({
                requestAll: 'songType/requestAll',
                setPage: 'songType/setPage',
                setSearch: 'songType/setSearch',
                setSave: 'songType/setSave',
                setEdit: 'songType/setEdit'
            }),
            initialize() {
                this.requestAll();
            },
            newItem(){
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
                this.setShowAddEditDialog(true);
            },
            editItem(item) {
                this.editedIndex = this.allList.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.setShowAddEditDialog(true)
            },
            close() {
                this.setShowAddEditDialog(false);
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1
            },
            save() {
                if (this.editedIndex > -1) {
                    if (this.editedItem.name.length === 0) {
                        return;
                    }
                    this.setEdit({itemToEdit: this.editedItem, itemIndex: this.editedIndex});
                } else {
                    if (this.editedItem.name.length === 0) {
                        return;
                    }
                    this.setSave(this.editedItem);
                }
            },
            paginate(page) {
                this.setPage(page);
            },
            searchAll() {
                this.setSearch(this.search);
            }
        },

    }
</script>

<style scoped>

</style>